import React, { useState, useEffect } from 'react';
import { t } from 'i18n';

import ModalV2 from 'Components/Base/ModalV2';

import ModalBody from './ModalBody';
import verifyEmailByTokenAndRegister from '../verifyEmailByTokenAndRegister';

const i18nOpts = { scope: 'registration.email_confirmation_modal' };

const getModalTitle = (step) => {
  switch (step) {
    case 'CODE_INPUT':
      return t('title', i18nOpts);
    case 'LINK_EXPIRED':
      return t('link_expired_title', i18nOpts);
    case 'SUCCESS':
    default:
      return t('success_title', i18nOpts);
  }
};

const getOnClose = (step, setIsOpen) => {
  switch (step) {
    case 'CODE_INPUT':
      return () => setIsOpen(false);
    case 'LINK_EXPIRED':
      return () => window.location.replace(window.location.href.split('?')[0]);
    case 'SUCCESS':
    default:
      return () => window.location.replace('/login');
  }
};

const EmailConfirmationModal = ({
  isOpen,
  setIsOpen,
  resendConfirmationEmailUrl,
  registrationUrl,
}) => {
  const [step, setStep] = useState('CODE_INPUT');
  const [errorType, setErrorType] = useState(null);
  const [emailToken, setEmailToken] = useState(null);

  useEffect(() => {
    let emailTokenParam = null;

    if (typeof window !== 'undefined') {
      const searchParams = new URLSearchParams(window.location.search);
      emailTokenParam = searchParams.get('email_confirmation_token');
      setEmailToken(emailTokenParam);
    }

    if (!emailTokenParam) return;

    verifyEmailByTokenAndRegister(
      emailTokenParam,
      registrationUrl,
      setErrorType,
      setStep,
      setIsOpen,
    );
  }, []);

  return (
    <ModalV2
      isOpen={isOpen}
      title={getModalTitle(step)}
      className="registrationV2__email_confirmation_modal"
      onClose={getOnClose(step, setIsOpen)}
    >
      <ModalBody
        registrationUrl={registrationUrl}
        resendConfirmationEmailUrl={resendConfirmationEmailUrl}
        setIsOpen={setIsOpen}
        step={step}
        errorType={errorType}
        setStep={setStep}
        setErrorType={setErrorType}
        emailToken={emailToken}
      />
    </ModalV2>
  );
};

export default EmailConfirmationModal;
